import { Schema } from 'further-types/lp/account';
import { isMongoId } from '../../helpers';
import { z } from 'zod';

const AccountSchema = z.object({
  section: z.nativeEnum(Schema.AccountSection),
  accountName: z.string().min(1, 'Please enter account name.'),
  accountCode: z.string().min(1, 'Please enter account code.'),
  payable: z.boolean().optional(),
  receivable: z.boolean().optional(),
  isPrepaidExpenses: z.boolean().optional(),
  isDeferredIncome: z.boolean().optional(),
  isBankTransferReceivable: z.boolean().optional(),
});

export const ListAll = z.object({
  searchQuery: z.string().optional().nullable(),
});

export const CreateAccount = AccountSchema.refine(
  (data) => {
    return !(data.payable && data.receivable);
  },
  {
    message: 'Payable and receivable cannot both be true',
  },
);

export const UpdateAccount = AccountSchema.extend({
  id: z.string().refine(isMongoId()),
}).refine(
  (data) => {
    return !(data.payable && data.receivable);
  },
  {
    message: 'Payable and receivable cannot both be true',
  },
);

export const DeleteAccount = z.object({
  id: z.string().refine(isMongoId()),
});
